import moment from "moment";
import type { ModifiersShape } from "react-dates";

/*
 * Partial list of modifiers given to renderDayContents by airbnb/react-dates. There may be more.
 *
 * today, blocked, blocked-calendar, blocked-out-of-range, highlighted-calendar, valid,
 * selected, selected-start, selected-end, blocked-minimum-nights, selected-span, last-in-range,
 * hovered, hovered-span, hovered-offset, after-hovered-start, first-day-of-week, last-day-of-week,
 * hovered-start-first-possible-end, hovered-start-blocked-minimum-nights, before-hovered-end,
 * no-selected-start-before-selected-end, selected-start-in-hovered-span, selected-start-no-selected-end,
 * selected-end-no-selected-start
 *
 * These predicates are the single source of truth for which visual state a day
 * cell is in. Both the static day cell (CalendarDayTailwind) and the preserved
 * styled one (styles.ts) read them, so the two paths cannot drift apart.
 */

export const isSelected = (modifiers: ModifiersShape) =>
  modifiers.has("selected-span") ||
  modifiers.has("selected") ||
  modifiers.has("selected-start") ||
  modifiers.has("selected-end") ||
  modifiers.has("hovered-span") ||
  modifiers.has("after-hovered-start");

export const isOutOfRange = (modifiers: ModifiersShape) =>
  modifiers.has("blocked-out-of-range");

export const isHoveredAndInRange = (modifiers: ModifiersShape) =>
  modifiers.has("hovered") && !modifiers.has("blocked-out-of-range");

export const shouldHaveLeftPill = (
  modifiers: ModifiersShape,
  day: moment.Moment
) => {
  if (!isSelected(modifiers)) {
    return false;
  }

  if (
    modifiers.has("selected") ||
    modifiers.has("selected-start") ||
    modifiers.has("first-day-of-week") ||
    day.isSame(moment(day).startOf("month"), "day")
  ) {
    return true;
  }

  return false;
};

export const shouldHaveRightPill = (
  modifiers: ModifiersShape,
  day: moment.Moment
) => {
  if (!isSelected(modifiers)) {
    return false;
  }

  if (
    modifiers.has("selected") ||
    modifiers.has("selected-end") ||
    modifiers.has("last-day-of-week") ||
    day.isSame(moment(day).endOf("month"), "day")
  ) {
    return true;
  }

  return false;
};
